<template>
    <div>
        <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                            cols="12"
                            md="8"
                            offset-md="2"
                    >
                        <h1 class="md-display-2 white--text mb-6">{{ $t('headings.Privacy Policy') }}</h1>
                        <v-card
                                class="mx-auto product-card"
                                outlined
                        >

                            <PrivacyPolicyContentNeotag v-if="brand === 'neotag'"/>
                            <PrivacyPolicyContent v-else/>

                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>

    import Footer from './Footer'
    import {i18n} from "../i18n";
    import {mapState} from "vuex";
    import PrivacyPolicyContent from "./PrivacyPolicyContent";
    import PrivacyPolicyContentNeotag from "./PrivacyPolicyContentNeotag"

    export default {
        name: "PrivacyPolicy",
        components: {
            'Footer': Footer,
            PrivacyPolicyContent,
            PrivacyPolicyContentNeotag
        },
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Privacy Policy'),
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              { name: 'description', content: i18n.t('This privacy policy applies between you, the User of this Website and {brand} Limited, the owner and provider of this Website', {brand: this.brandName}) + '.' }
            ]
          }
        },
        mounted () {

            this.$gtag.pageview({
                page_path: '/privacy-policy'
            })

            document.getElementById("scrolling-content").scrollTop = 0

            window.prerenderReady = true;
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName
          }),
          getBackground() {
            if (this.brand === 'neotag') {
              return require('@/assets/neotag-background.jpg')
            }
            else {
              return require('@/assets/neotag-background.jpg')
            }
          },
        },
        methods: {
          capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
          },
        }
    }
</script>

<style scoped>
    ol {
        margin-bottom: 16px;
    }

    ol li {
        margin-bottom: 4px;
    }

    h2 {
        margin-top: 24px;
        margin-bottom: 8px;
    }
</style>
